module.exports = __webpack_public_path__ + "static/media/whitewiley.7ec1d29c.png";